import type { NoteRecord } from '@/types/note';
import NoteSheet from './NoteSheet';

interface PrintAreaProps {
  notes: NoteRecord[];
}

/**
 * 인쇄 시에만 화면에 나타나는 전용 영역입니다.
 * 체크로 선택한 시험(또는 전체)의 오답노트를 이곳에 담아 window.print()로 출력합니다.
 */
export default function PrintArea({ notes }: PrintAreaProps) {
  if (notes.length === 0) return null;
  return (
    <div className="print-only-area notes-print-area">
      {notes.map((note) => (
        <NoteSheet key={note.id} note={note} onChange={() => {}} onDelete={() => {}} />
      ))}
    </div>
  );
}